<template>
    <div class="c-limited-subscription-summary">
        <b-card no-body>
            <div slot="header">
                {{caption}}
                <div v-if="options.displayAddProduct" class="card-header-actions pull-right">
                    <b-button @click="open" type="button" variant="info">{{Core.Definition.getDefinition('Sélection produit')}}</b-button>
                </div>
            </div>
            <b-card-body>
                <ModalInstanceSelector
                        :caption="Core.Definition.getDefinition('Liste des produits')"
                        v-if="options.displayAddProduct"
                        ref="modalInstanceSelector"
                        root="/product/list"
                        quantityStep="bookingLimit"
                        v-model="dataProducts"
                        :multiple="false"
                        :searchFormStructure="{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'id',
                                    type: 'number',
                                    label: Core.Definition.getDefinition('ID'),
                                    value: ''
                                },
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        }"
                        :searchArgs="[
                            {
                                key: 'type',
                                value: Core.Product.typeRecurringSubscription
                            }
                        ]"
                        :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucun produit recurrent à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                        :columns="[
                                {
                                    label: Core.Definition.getDefinition('#'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Prix régulier'),
                                    key: 'Readable.regularPrice',
                                    type: 'text',
                                    sortable: true
                                }
                         ]"></ModalInstanceSelector>


                <template v-if="!Core.Validation.isId(dataValue.productId)&&!Core.Validation.isId(dataValue.recurringSubscriptionProductId)">
                    <b-alert show variant="light">
                        {{Core.Definition.getDefinition('Veuillez sélectionner un produit récurrent.')}}
                    </b-alert>
                </template>

                <template v-if="Core.Validation.isId(dataValue.productId)||Core.Validation.isId(dataValue.recurringSubscriptionProductId)">
                    <b-row class="mt-3">
                        <b-col v-if="options.displayTitle">
                            <strong>{{dataValue.title}}</strong><br/>
                            <small v-if="dataValue.shortDescription !== ''">{{dataValue.shortDescription}}</small>
                            <small v-else>{{Core.Definition.getDefinition('Aucune description courte disponible')}}</small>
                        </b-col>
                        <b-col sm="12" md="6" lg="6">
                            <InputCurrency
                                    :label="Core.Definition.getDefinition('Montant par paiement')"
                                    v-model="dataValue.amount"></InputCurrency>
                        </b-col>
                    </b-row>

                    <strong class="mt-4">
                        {{Core.Definition.getDefinition('Durée de l\'abonnement')}}
                    </strong>
                    <b-row class="mt-3">
                        <b-col lg="6" md="6" sm="12">
                            <InputNumber
                                    v-model="dataValue.periodLength"></InputNumber>
                            <b-button @click="evalPeriodDates" class="btn btn-sm btn-light mr-2">{{Core.Definition.getDefinition('Recalculer les dates')}}</b-button>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <InputSelect
                                    :options="Core.Product.periodOptions()"
                                    v-model="dataValue.period"></InputSelect>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col lg="6" md="6" sm="12">
                            <InputDatePicker
                                    :isInline="false"
                                    :label="Core.Definition.getDefinition('Début')"
                                    v-model="dataValue.start"></InputDatePicker>
                        </b-col>
                        <b-col lg="6" md="6" sm="12">
                            <InputDatePicker
                                    :isInline="false"
                                    :label="Core.Definition.getDefinition('Fin')"
                                    v-model="dataValue.end"></InputDatePicker>
                        </b-col>
                    </b-row>
                    <hr/>
                    <strong class="mt-4">
                        {{Core.Definition.getDefinition('Durée des paiements')}}
                    </strong>
                    <b-row class="mt-3">
                        <b-col lg="4" md="6" sm="12">
                            <InputSelect
                                    :options="Core.Product.periodIntervalOptions()"
                                    v-model="dataValue.periodPaymentInterval"></InputSelect>
                            <b-button @click="evalPayments" class="btn btn-sm btn-light">{{Core.Definition.getDefinition('Recalculer les paiements')}}</b-button>
                        </b-col>
                        <b-col lg="4" md="6" sm="12">
                            <InputSelect
                                    :options="Core.Product.periodOptions()"
                                    v-model="dataValue.periodPayment"></InputSelect>
                        </b-col>
                        <b-col lg="4" md="6" sm="12">
                            <InputNumber
                                    v-model="dataValue.periodPaymentLength"></InputNumber>
                        </b-col>
                    </b-row>

                    <hr/>
                    <b-row class="mt-3">
                        <b-col lg="6">
                            <InputCheckbox
                                    :label="Core.Definition.getDefinition('Limiter les réservations')"
                                    v-model="dataValue.bookingLimitManagement"></InputCheckbox>
                        </b-col>
                    </b-row>
                    <b-row v-if="dataValue.bookingLimitManagement" class="mt-3">
                        <b-col>
                            <InputNumber
                                    :label="Core.Definition.getDefinition('Limite de participations')"
                                    :description="Core.Definition.getDefinition('Le nombre de participation sera réinitialisé à la fin de chaque période')"
                                    v-model="dataValue.bookingLimit"></InputNumber>
                        </b-col>
                        <b-col>
                            <InputSelect
                                    :label="Core.Definition.getDefinition('Intervale')"
                                    :options="Core.Product.periodIntervalOptions()"
                                    v-model="dataValue.bookingLimitInterval"></InputSelect>
                        </b-col>
                        <b-col>
                            <InputSelect
                                    :label="Core.Definition.getDefinition('Période')"
                                    :options="Core.Product.periodOptions()"
                                    v-model="dataValue.bookingLimitPeriod"></InputSelect>
                        </b-col>
                    </b-row>
                </template>

            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import InputDatePicker from './InputDatePicker'
    import ProductSummary from './ProductSummary'
    import ModalInstanceSelector from './ModalInstanceSelector'
    import InputSelect from './InputSelect'
    import InputCheckbox from './InputCheckbox'
    import InputText from './InputText'
    import InputDate from './InputDate'
    import InputCurrency from './InputCurrency'
    import InputNumber from './InputNumber'
    export default {
        name: 'ProductRecurringSubscriptionSummary',
        components: {
            ProductSummary,
            ModalInstanceSelector,
            InputDatePicker,
            InputSelect,
            InputText,
            InputCurrency,
            InputDate,
            InputNumber,
            InputCheckbox
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        displayAddProduct: true,
                        displayTitle: true
                    }
                }
            },
            id: {
                type: String,
                default: ''
            },
            caption: {
                type: String,
                default: ''
            },
            form: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Object,
                default: function () {
                    return  {
                        recurringSubscriptionProductId: '',
                        title: '',
                        shortDescription: '',
                        productId: '',
                        amount: '0',
                        periodLength: '0',
                        period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                        periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                        periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                        periodPaymentLength: '0',
                        bookingLimitManagement: false,
                        bookingLimit: '0',
                        bookingLimitPeriod: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                        bookingLimitInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                        start: null,
                        end: null,
                        isTaxable: true
                    }
                }
            },
            updateTotal: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            onChange: {
                type: Function,
                default: function () {
                    return 0
                }
            },
            onEvalPayments: {
                type: Function,
                default: function () {
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataValue = val
                },
                deep: true
            },
            dataProducts: {
                handler(val) {
                    this.evalSubscriptionSummary()
                    this.onChange(val, this.form, this.fieldRefs)
                },
                deep: true
            },
            dataValue: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataValue = this.value
        },
        data: () => {
            return {
                Core: window.Core,
                dataProducts: [],
                dataValue:  {
                    recurringSubscriptionProductId: '',
                    title: '',
                    shortDescription: '',
                    productId: '',
                    amount: '0',
                    periodLength: '0',
                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                    periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentLength: '0',
                    bookingLimitManagement: false,
                    bookingLimit: '0',
                    bookingLimitPeriod: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    bookingLimitInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                    start: null,
                    end: null,
                    isTaxable: true
                }
            }
        },
        methods: {
            chkState(val) {
                if (this.form !== undefined && this.form[val] !== undefined) {
                    const field = this.form[val]
                    return !field.$dirty || !field.$invalid
                }
            },
            open() {
                this.$refs.modalInstanceSelector.open = true
            },
            evalSubscriptionSummary() {
                if (this.dataProducts[0] !== undefined) {
                    if (this.dataProducts[0].instance !== undefined) {
                        let product = this.dataProducts[0].instance
                        this.dataValue.amount = product.regularPrice.replace('.', ',')
                        this.dataValue.title = product.title
                        this.dataValue.isTaxable = product.isTaxable
                        this.dataValue.shortDescription = product.shortDescription
                        this.dataValue.productId = product.id
                        this.dataValue.periodPaymentInterval = Core.Select.select(product.periodPaymentInterval, Core.Product.periodIntervalOptions())
                        this.dataValue.periodPayment = Core.Select.select(product.periodPayment, Core.Product.periodOptions())
                        this.dataValue.periodPaymentLength = product.periodPaymentLength
                        this.dataValue.period = Core.Select.select(product.period, Core.Product.periodOptions())
                        this.dataValue.periodLength = product.periodLength
                        this.dataValue.bookingLimitManagement = Core.Value.encode(product.bookingLimitManagement, Core.Value.typeCheckbox)
                        this.dataValue.bookingLimit = product.bookingLimit
                        this.dataValue.bookingLimitPeriod = Core.Select.select(product.bookingLimitPeriod, Core.Product.periodOptions())
                        this.dataValue.bookingLimitInterval = Core.Select.select(product.bookingLimitInterval, Core.Product.periodIntervalOptions())
                        this.evalPeriodDates()
                        this.evalPayments()
                    }
                }
            },
            evalPeriodDates() {
                let start = Core.Date.getToday()
                let end = Core.Date.calc(Core.Select.value(this.dataValue.period), this.dataValue.periodLength, 'YYYY-MM-DD', start)

                this.dataValue.start = Core.Value.encode(start, 'datePicker')
                this.dataValue.end = Core.Value.encode(end, 'datePicker')
            },
            evalPayments() {
                let start = Core.Value.decode(this.dataValue.start, 'datePicker')
                let end = Core.Value.decode(this.dataValue.end, 'datePicker')

                let amount = this.dataValue.amount
                let periodPayment = Core.Select.value(this.dataValue.periodPayment)
                let periodPaymentInterval = Core.Select.value(this.dataValue.periodPaymentInterval)
                let periodPaymentLength = this.dataValue.periodPaymentLength

                let dates = []
                let date = start
                let i = 0
                while(i < periodPaymentLength) {
                    dates.push(date)
                    switch(periodPaymentInterval) {
                        case Core.Product.periodIntervalTwo:
                            i = i + 2
                            break
                        default:
                            i++
                            break
                    }
                    date = Core.Date.calc(periodPayment, i, 'YYYY-MM-DD', start)
                }
                this.onEvalPayments(dates, this.dataValue, this.form, this.fieldRefs)
            }
        }
    }
</script>
